import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-compliance',
  templateUrl: './dashboard-compliance.component.html',
  styleUrl: './dashboard-compliance.component.scss',

})
export class DashboardComplianceComponent {

  isLoading = false;
  isContentScrolled = false;


  scroll({ reachedTop = false }) {
    this.isContentScrolled = !reachedTop;
  }

  navigateToDetails(event: any) {
    console.log('Navigating to details for:', event.data);
    // Add your navigation logic here
    // Example: this.router.navigate(['/details', event.data.id]);
  }


}
